import type { JsonCustomConvert } from 'json2typescript'
import type { TierEnum } from '@/services/enums/TierEnum'
import { JsonConverter } from 'json2typescript'

@JsonConverter
export default class SchemeTierEnumConverter implements JsonCustomConvert<TierEnum> {
  serialize(schemeTier: TierEnum): string {
    return schemeTier.toString()
  }

  deserialize(schemeTier: string): TierEnum {
    return schemeTier as TierEnum
  }
}
